export { default } from "./BookingSettingsTemplate"